import ButtonGroup from 'components/utils/ButtonGroup';
import useResponsive from 'hooks/useResponsive';
import useTranslation from 'hooks/useTranslation';
import React from 'react';

import DropshippingCard from './DropshippingCard';
import style from './index.style';

export default function DropshippingPlan({
  plan,
  getRadioGroupTabs,
  selectedPeriodicity,
  setSelectedPeriodicity,
  goingDown,
  promoPrice,
  plans,
}) {
  const { TRANSLATIONS } = useTranslation();
  const { isMobile, isTablet, isLaptop } = useResponsive();
  const isSmallDevice = isMobile || isTablet || isLaptop;
  return (
    <div className="plans-section d-f jc-c ai-c fd-c">
      <div className="title-plans">
        <h3>{TRANSLATIONS.pricing.drop.title}</h3>
        <p>{TRANSLATIONS.pricing.drop.paragraph}</p>
      </div>
      <div
        className={`relative wrap-button ${goingDown && isMobile && 'sticky'}`}
      >
        <ButtonGroup
          className="button-group"
          tabs={getRadioGroupTabs}
          selectedItem={selectedPeriodicity}
          setSelectedItem={setSelectedPeriodicity}
        />
        {promoPrice && (
          <>
            <img
              className="switch-plan-arrow"
              src="arrow_pricing.svg"
              width={18}
              alt="arrow-pricing"
            />
            <div
              className={`switch-plan-position ${
                promoPrice && 'promo-active-'
              }`}
            >
              {promoPrice
                ? TRANSLATIONS.pricing.discount.limitedTimeOffer
                : TRANSLATIONS.pricing.discount.yearly}
            </div>
          </>
        )}
      </div>
      <div className={`plans ${isSmallDevice && 'fw-w'}`}>
        {plan
          .filter((a) => a.planCode !== 'shopify')
          .sort((a, b) => {
            if (a.suggestedPrice < b.suggestedPrice) return -1;
            return 0;
          })
          .map((plan) => (
            <DropshippingCard
              plan={plan}
              key={plan._id}
              promoPrice={promoPrice}
              plans={plans}
            />
          ))}
      </div>
      <div className="sub-text mb-xl">
        {TRANSLATIONS.pricing.descriptionPlan}
      </div>
      <style jsx>{style}</style>
    </div>
  );
}
